<template>
  <div class="setup_step card">
    <h4>Do you have a Stripe Account?</h4>
    <p class="step-description">
      Hike’s Merchant Centre works with the payment platform Stripe to enable you to receive payments from your
      customers (<span v-html="learnMoreLink" />). To continue, you will need to either create a new Stripe account or connect your existing account if you are
      a current Stripe user.
    </p>
    <button
      class="button info"
      :disabled="loading"
      @click="fetchOnboardingLinkAndRedirect"
    >
      Yes, link my account
    </button>
    <button
      class="button"
      :disabled="loading"
      @click="connectStripeAccount"
    >
      No, I need to create an account
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  computed: {
    ...mapGetters('merchantCentreSetupWizard', [
      'loading'
    ]),
    learnMoreLink() { // Added for cleaner code, linter didn't like single-line <a>
      return 'learn more about Stripe <a href="https://stripe.com/" target="_blank">here</a>';
    }
  },
  async mounted() {
    await this.fetchWhitelabelStatus();
  },
  methods: {
    ...mapActions('merchantCentreSetupWizard', [
      'fetchWhitelabelStatus',
      'setLoadingState',
    ]),
    connectStripeAccount() {
      Swal.fire({
        icon: 'warning',
        title: 'Please note',
        html: 'The process for creating a Stripe account can take up to 15 minutes.<br><br>We recommend you '+
          'ensure you have enough time to complete this, and have the necessary information required for creating a '+
          'Stripe account, such as business details and bank details.',
        reverseButtons: true,
        confirmButtonText: "I'm ready",
        confirmButtonColor: '#37b2a8',
        allowOutsideClick: false,
        showCancelButton: true,
      }).then(result => {
        if (result.isConfirmed) {
          this.fetchOnboardingLinkAndRedirect();
        }
      })
    },
    fetchOnboardingLinkAndRedirect() {
      this.setLoadingState(true);
      axios.get('/merchant/connect-stripe-account')
        .then(({ data }) => {
          const { success } = data;
          if (success === true) {
            this.redirectToOnboarding();
            return;
          }
          this.displayError('Something went wrong, please try again later.');
          this.setLoadingState(false);
        })
        .catch((e) => this.$axiosExceptionHandler(e, this.handleXHRError));
    },
    redirectToOnboarding() {
      axios.get('/merchant/stripe-onboarding')
        .then(({ data }) => {
          const { success, onboarding_link } = data;
          if (success === true && onboarding_link) {
            window.location.replace(onboarding_link);
            return;
          }
          this.setLoadingState(false);
          this.displayError('Something went wrong, please try again later.');
        })
        .catch((e) => this.$axiosExceptionHandler(e, this.handleXHRError));
    },
    handleXHRError({ response }) {
      if (response.status === 422) {
        const { errors } = response.data;
        this.errors = errors;
      } else {
        const { data } = response;
        this.displayError(data.message ?? 'Something went wrong, please try again later.');
      }
      this.setLoadingState(false);
    },
    displayError(message) {
      Swal.fire({
        title: "Whoops",
        html: message,
        icon: 'warning',
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.merchant_centre_wizard {
  .setup_form {
    .setup_step {
      > h4 {
        margin-bottom: 1rem;
      }

      .button {
        margin-bottom: 1rem;

        &.info {
          border-radius: 12px;
          padding: 1rem;
          font-size: 1.5rem;
          line-height: 2.125rem;
          font-weight: 700;
          width: 100%;
          color: #4E4E54;
          border: 2px solid #E8E5E2;
        }
      }
    }
  }
}
</style>
